import { Input } from '@/components/ui/input';
import { qrCodeCtaChanged } from '@/providers/AdminEngagementProvider/actions';
import { useAdminEngagementContext } from '@/providers/AdminEngagementProvider/AdminEngagementContext';

export function QRCodeCtaInput() {
  const {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    state: { editorMode, ...engagement },
    dispatch,
  } = useAdminEngagementContext();

  return (
    <Input
      id="qr-code-cta"
      value={engagement.qrCodeCta || ''}
      onChange={(e) =>
        dispatch(
          qrCodeCtaChanged({
            qrCodeCta: e.target.value,
          }),
        )
      }
    />
  );
}
